<template>
	<div>
		<span itemprop="description" id="desc_collapse" class="out" v-html="desc_text"></span>
		<a id="lnk_collapse" v-if="height > 448" v-on:click="collapse()" class="text-custom" href="javascript:void(0);">{{ lnk_text }}</a>
	</div>
</template>

<script>
	export default {
		props: ['desc_text'],

		data: function () {
			return {
				index: 0,
				arr_lnk: ['Ver Mais', 'Ver Menos'],
				lnk_text: '',
				height: 0
			}
		},

		methods: {
			collapse: function () {
				this.index = 1 - this.index;
				this.lnk_text = this.arr_lnk[this.index];
				$('#desc_collapse').toggleClass('out');
			}
		},

		mounted: function () {
			this.height = $('#desc_collapse').height();
			this.lnk_text = this.arr_lnk[this.index];
		}
	}
</script>

<style>
	#desc_collapse {
		transition: 0.2s all;
		display: block;
	}

	#desc_collapse.out {
		overflow: hidden;
		max-height: 450px;
	}
</style>
